<template>
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Cost & Acquisition
        <small>Report</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Cost & Acquisition</a></li>
        <li class="active">Report</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <!-- show the first line chart with the records for all the channels -->
              <all-channel-stats></all-channel-stats>

              <!-- for each channel statistics -->
              <channel-stats></channel-stats>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import ChannelStats from './ChannelStats.vue'
import AllChannelStats from './AllChannelsStats.vue'

export default {
  components: {
    AllChannelStats,
    ChannelStats
  }
}
</script>



// WEBPACK FOOTER //
// Statistics.vue?0c8470b9